<app-pagetitle title="INDICADORES" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
    <div class="col-xl-12">
        <div class="card">
            <div class="card-body">

                <ul class="nav nav-tabs">
                    <li class="nav-item">
                       <a href="#objetivo" data-bs-toggle="tab" aria-expanded="false" class="nav-link active " (click)="openObjetivos()">
                            Objetivos
                        </a>
                    </li>
                    <li *ngIf="idSprNivelN5 != nivelSelect" class="nav-item">
                        <a href="#linea-accion" data-bs-toggle="tab" aria-expanded="true" class="nav-link " (click)="openLineasAccion()">
                            Líneas de acción
                        </a>
                    </li>
                    <li *ngIf="idSprNivelN5 == nivelSelect" class="nav-item">
                        <a href="#planes-accion" data-bs-toggle="tab" aria-expanded="true" class="nav-link " (click)="openPlanesAccion()">
                           Planes de acción
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#proyectos" data-bs-toggle="tab" aria-expanded="false" class="nav-link " (click)="openProyectos()">
                            Proyectos
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#procesos" data-bs-toggle="tab" aria-expanded="true" class="nav-link " (click)="openProcesos()">
                            Procesos
                        </a>
                    </li>
                </ul>
                <div class="tab-content">

                    <div class="tab-pane show active " id="objetivo">
                    <div  *ngIf="objetivo != '-'">   
                       <!-- ############################### OBJETIVOS ##################################### -->
                      <app-indicadores-objetivos [init]="objetivo" [idsObjetivos]="dataObjetivosPorAnio" [planAnual]="planAnioSeleccionadoRedux"></app-indicadores-objetivos>                               
                       <!-- ################################## FIN OBJETIVOS ############################## -->
                    </div> 
                    </div> 

                    <div class="tab-pane " id="linea-accion">
                        <div  *ngIf="lineAction != '-'">                        
                            <!--###################    LINEAS DE ACCION   ########################################-->
                        <app-indicadores-linea-accion [init2]="lineAction" [idsObjetivos]="dataObjetivosPorAnio" [planAnual]="planAnioSeleccionadoRedux"></app-indicadores-linea-accion>
                        <!--###################   FIN LINEAS DE ACCION   #####################################-->
                    </div>
                    </div>

                   <div class="tab-pane  " id="planes-accion">
                    <div  *ngIf="planAccion != '-'">
                        <app-indicadores-plan-accion [init3]="planAccion"></app-indicadores-plan-accion>
                    </div>
                    </div>

                    <div class="tab-pane  " id="proyectos">
                        <div  *ngIf="proyecto != '-'">
                       <!-- ####################### PROYECTOS  ############################################# -->
                       <app-indicadores-proyectos [init]="proyecto"></app-indicadores-proyectos>                
                       <!-- ####################### FIN  PROYECTOS  ######################################## -->
                    </div>
                    </div>

                    <div class="tab-pane  " id="procesos">
                        <div  *ngIf="proceso != '-'">
                       <!-- ########################### PROCESOS ########################################### -->              
                       <app-indicadores-procesos [init]="proceso" ></app-indicadores-procesos>                                
                       <!-- ########################### FIN PROCESOS ####################################### -->
                    </div>
                    </div>

                </div>
            </div>
        </div> <!-- end card-->
    </div> <!-- end col -->
</div>
<!-- end row -->

<!-- ############################################################################################################# -->
<!-- ######################################    MODALES       ##################################################### -->
<!-- ############################################################################################################# -->

